import { Map as OLMap, MapBrowserEvent } from 'ol';
import { toLonLat } from 'ol/proj';

import { MapCommand } from 'controllers';

type ClickEvent = (coords: number[], event: MapBrowserEvent<UIEvent>) => void;

export class MouseClick implements MapCommand {
    constructor(
        onClick: ClickEvent,
        private stopPropagation = false,
        private highPriority = false,
    ) {
        this.onClick = onClick;
    }

    private onClick: ClickEvent;

    private handler?: (event: MapBrowserEvent<UIEvent>) => void | boolean;

    private event?: MapBrowserEvent<UIEvent>;

    private map?: OLMap;

    apply(map: OLMap) {
        if (this.handler) map.un('click', this.handler);

        this.handler = (event) => {
            this.event = event;
            this.onClick(toLonLat(event.coordinate), event);
            if (this.stopPropagation) {
                event.stopPropagation();
                return false;
            }
        };
        this.map = map;

        if (this.highPriority) {
            // Is a hacky way to make sure
            // this handler is executed at the very top
            // (unless if other highPriority click events are addded after this)
            // Generally useful if you have a single click action
            // @ts-ignore
            map.getListeners('click')?.unshift(this.handler);
        } else {
            map.on('click', this.handler);
        }
    }

    update(onClick: ClickEvent) {
        this.onClick = onClick;
    }

    rerunLastClick() {
        if (this.event)
            this.onClick(toLonLat(this.event.coordinate), this.event);
    }

    clear() {
        if (this.handler && this.map) this.map.un('click', this.handler);
    }
}

export default MouseClick;
